import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

	show = true;

  constructor(public auth: AuthService) { }

  ngOnInit() {
  }

	close(){
    this.show = false;
  }

}
